 //const baseUrl="http://172.16.10.68:8582/wx/";//线上
// const baseUrl="https://cfyyt.com/";//最新线上
const baseUrl="http://47.108.93.193:8090/jinxin/webapi/";//本地
const httpRequest = (opts, data) => {e
	let httpDefaultOpts = {
		url: baseUrl + opts.url,
		data: data,
		method: opts.method,
		header: opts.method == 'get' ? {
			'X-Requested-With': 'XMLHttpRequest',
			"Accept": "application/json",
			"Content-Type": "application/json; charset=UTF-8"
		} : {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		dataType: 'json',
	}
	let promise = new Promise(function(resolve, reject) {
		uni.request(httpDefaultOpts).then(
			(res) => {
				resolve(res[1].data)
			}
		).catch(
			(response) => {
				reject(response)
			}
		)
	})
	return promise
};

const get = (url, data) => {
  console.log('----------------请求启动')
	let httpDefaultOpts = {
		url: baseUrl + url,
		data: data,
		method: 'GET',
		// header: {
		// 	'content-type': 'application/x-www-form-urlencoded',
		// 	'X-Litemall-Token':uni.getStorageSync('token')
		// },
		dataType: 'json',
	}
	let promise = new Promise(function(resolve, reject) {
		uni.request(httpDefaultOpts).then(
			(res) => {
				resolve(res[1].data)
				if(res[1].data.code!=0){
					uni.showToast({
						icon:'loading',
						title:res[1].data.info
					})
				}
				if(res[1].data.code==-1009){
					uni.navigateTo({
						url:"/pages/login/login"
					})
				}
			}
		).catch(
			(response) => {
				reject(response)
			}
		)
	})
	return promise
};

const post = (url, data) => {
	let httpDefaultOpts = {
		url: baseUrl + url,
		data: data,
		method: 'POST',
		header: {
			'content-type': 'application/json',
			'X-Litemall-Token':uni.getStorageSync('token')
		},
		dataType: 'json',
	}
	let promise = new Promise(function(resolve, reject) {
		uni.request(httpDefaultOpts).then(
			(res) => {
				resolve(res[1].data)
				if(res[1].data.code!=0){
					uni.showToast({
						icon:'loading',
						title:res[1].data.info
					})
				}
				if(res[1].data.code==-1009){
					uni.navigateTo({
						url:"/pages/login/login"
					})
				}

			}
		).catch(
			(response) => {
				reject(response)
			}
		)
	})
	return promise
};





export default {
	baseUrl,
	httpRequest,
	get,
	post
}



//////////////////
// WEBPACK FOOTER
// ./until/api.js
// module id = null
// module chunks = 